// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"cad2b394","453":"d8c311ae"}[chunkId] + ".chunk.js";
};